import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import MyComponen from '@/components';

// 按需引入 Ant Design Vue 组件
import {
  Button,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Checkbox,
  Radio,
  Cascader,
  TreeSelect,
  Switch,
  Upload,
  Image,
  Modal,
  Drawer,
  Form,
  Table,
  Popover,
  ConfigProvider,
  Tabs,
  Tooltip,
  Spin,
  Menu,
  Dropdown,
  Layout,
  Badge,
  Card,
  Row,
  Col,
  Tag,
  Collapse,
  Steps,
  Tree,
  Result
} from 'ant-design-vue';

import '@/style/global.less';
import '@/style/fonts/fonts.css'
import '@/style/fonts/menu.css'

import {initECharts} from "@/utils/echarts-init";

const app = createApp(App);

app.config.globalProperties.log = msg => console.log(msg);
app.config.globalProperties.alert = msg => alert(msg);
app.config.globalProperties.window = window;

// 注册 Ant Design Vue 组件
app.use(Button);
app.use(Input);
app.use(Select);
app.use(DatePicker);
app.use(InputNumber);
app.use(Checkbox);
app.use(Radio);
app.use(Cascader);
app.use(TreeSelect);
app.use(Switch);
app.use(Upload);
app.use(Image);
app.use(Modal);
app.use(Drawer);
app.use(Form);
app.use(Table);
app.use(Popover);
app.use(ConfigProvider);
app.use(Tabs);
app.use(Tooltip);
app.use(Spin);
app.use(Menu);
app.use(Dropdown);
app.use(Layout);
app.use(Badge);
app.use(Card);
app.use(Row);
app.use(Col);
app.use(Tag);
app.use(Collapse);
app.use(Steps);
app.use(Tree);
app.use(Result);

app.use(router);
app.use(store);
app.use(MyComponen);
app.mount('#app');

initECharts();